<script lang="ts">
	import { LINK } from '@papyria/ui';
	import * as m from '#lib/paraglide/messages.js';
	import { localizeHref } from '#lib/paraglide/runtime.js';
</script>

<footer class="border-t border-rule">
	<div
		class="mx-auto flex w-full max-w-6xl flex-wrap items-baseline justify-between gap-x-6 gap-y-2 px-6 py-6 text-sm"
	>
		<div class="flex flex-wrap gap-x-6 gap-y-2">
			<a href={localizeHref('/privacy')} class={LINK}>{m.footer_privacy()}</a>
			<a href={localizeHref('/ai-principles')} class={LINK}>{m.footer_ai_policy()}</a>
		</div>
		<p class="text-muted">{m.footer_no_tracking()}</p>
	</div>
</footer>
